import { render, staticRenderFns } from "./OverviewResult.vue?vue&type=template&id=4a955f52&"
import script from "./OverviewResult.vue?vue&type=script&lang=js&"
export * from "./OverviewResult.vue?vue&type=script&lang=js&"
import style0 from "./OverviewResult.vue?vue&type=style&index=0&id=4a955f52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports